import * as history from 'history';
import { createHistoryPath } from './create-history-path';
import { createKey } from './create-key';
export class HistoryMultiplexer {
    constructor(rootHistory, rootLocationTransformer) {
        this.rootHistory = rootHistory;
        this.rootLocationTransformer = rootLocationTransformer;
        this.rootHistoryV2 = {
            get length() {
                try {
                    return window.history.length;
                }
                catch (_a) {
                    return 1;
                }
            },
            get location() {
                return rootHistory.location;
            },
            push(location) {
                const newPath = getNewPath(location, rootHistory.location);
                rootHistory.push(newPath, location.state);
            },
            replace(location) {
                const newPath = getNewPath(location, rootHistory.location);
                rootHistory.replace(newPath, location.state);
            },
            createHref(location) {
                return rootHistory.createHref(location);
            },
            listen(listener) {
                return rootHistory.listen(({ location, action }) => listener(location, action));
            },
        };
    }
    get rootLocation() {
        return this.rootHistory.location;
    }
    push(historyKey, consumerLocation) {
        const { pathname, search, hash, state } = this.createRootLocation(historyKey, consumerLocation);
        this.rootHistory.push({ pathname, search, hash }, state);
    }
    replace(historyKey, consumerLocation) {
        const { pathname, search, hash, state } = this.createRootLocation(historyKey, consumerLocation);
        this.rootHistory.replace({ pathname, search, hash }, state);
    }
    createHref(historyKey, consumerLocation) {
        const { pathname, search, hash } = this.createRootLocation(historyKey, consumerLocation);
        return this.rootHistory.createHref({ pathname, search, hash });
    }
    getConsumerLocation(historyKey) {
        var _a;
        const consumerPath = this.rootLocationTransformer.getConsumerPathFromRootLocation(this.rootLocation, historyKey) || '/';
        const { state, key } = ((_a = this.rootLocation.state) === null || _a === void 0 ? void 0 : _a[historyKey]) || {
            state: undefined,
            key: createKey(),
        };
        return Object.assign(Object.assign({}, createHistoryPath(history.parsePath(consumerPath))), { state,
            key });
    }
    listenForRootLocationChange(listener) {
        return this.rootHistory.listen(({ action }) => {
            listener(action);
        });
    }
    createNewRootLocationForMultipleConsumers(...consumerLocations) {
        let newRootLocation = { pathname: '/' };
        if (this.rootLocationTransformer.createNewRootLocationForMultipleConsumers) {
            newRootLocation =
                this.rootLocationTransformer.createNewRootLocationForMultipleConsumers(...consumerLocations);
        }
        else {
            for (const consumerLocation of consumerLocations) {
                newRootLocation = this.rootLocationTransformer.createRootLocation(newRootLocation, consumerLocation.location, consumerLocation.historyKey);
            }
        }
        const consumerStates = {};
        for (const { historyKey, state } of consumerLocations) {
            consumerStates[historyKey] = { state, key: createKey() };
        }
        return Object.assign(Object.assign({}, createHistoryPath(newRootLocation)), { state: consumerStates });
    }
    createRootLocation(historyKey, consumerLocation) {
        const newRootLocation = this.rootLocationTransformer.createRootLocation(this.rootLocation, consumerLocation, historyKey);
        const { state, key = createKey() } = consumerLocation;
        return Object.assign(Object.assign({}, createHistoryPath(newRootLocation)), { state: Object.assign(Object.assign({}, this.rootLocation.state), { [historyKey]: { state, key } }) });
    }
}
/**
 * Create new path from existing and new partial path
 * @param location new path
 * @param currentLocation current path
 * @returns
 */
function getNewPath(location, currentLocation) {
    if (location.pathname !== undefined) {
        return location;
    }
    if (location.search !== undefined) {
        return {
            pathname: currentLocation.pathname,
            search: location.search,
            hash: location.hash,
        };
    }
    return {
        pathname: currentLocation.pathname,
        search: currentLocation.search,
        hash: location.hash,
    };
}
//# sourceMappingURL=history-multiplexer.js.map